import axios from 'axios';
import config from './config';

const instance = axios.create({
    baseURL: config.baseurl,
    // timeout: 10000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',



























































});

export default instance;